var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMeasurableResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_measurable_results_svg__mask0_9071_1061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_measurable_results_svg__mask0_9071_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.231 40c-.92 0-1.69-.308-2.306-.925C7.308 38.458 7 37.69 7 36.769V6h2v30.769c0 .308.128.59.384.846.257.257.539.385.847.385H41v2H10.231zm4.538-7V18.384h4V33h-4zm9 0V8.384h4V33h-4zm9 0v-6.616h4V33h-4z",
    fill: "url(#icon_measurable_results_svg__paint0_linear_9071_1061)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_measurable_results_svg__paint0_linear_9071_1061",
    x1: -7.747,
    y1: 22.973,
    x2: 48.771,
    y2: 22.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#E43425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#441FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzkwNzFfMTA2MSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4Ij4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF85MDcxXzEwNjEpIj4KPHBhdGggZD0iTTEwLjIzMSA0MEM5LjMxMDMzIDQwIDguNTQxNjcgMzkuNjkxNyA3LjkyNSAzOS4wNzVDNy4zMDgzMyAzOC40NTgzIDcgMzcuNjg5NyA3IDM2Ljc2OVY2SDlWMzYuNzY5QzkgMzcuMDc3IDkuMTI4MTcgMzcuMzU5MiA5LjM4NDUgMzcuNjE1NUM5LjY0MDgzIDM3Ljg3MTggOS45MjMgMzggMTAuMjMxIDM4SDQxVjQwSDEwLjIzMVpNMTQuNzY5IDMzVjE4LjM4NDVIMTguNzY5VjMzSDE0Ljc2OVpNMjMuNzY5IDMzVjguMzg0NUgyNy43NjlWMzNIMjMuNzY5Wk0zMi43NjkgMzNWMjYuMzg0NUgzNi43Njk1VjMzSDMyLjc2OVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl85MDcxXzEwNjEpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl85MDcxXzEwNjEiIHgxPSItNy43NDcxMyIgeTE9IjIyLjk3MjUiIHgyPSI0OC43NzA5IiB5Mj0iMjIuODQyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4zMTc3MDgiIHN0b3AtY29sb3I9IiNFNDM0MjUiLz4KPHN0b3Agb2Zmc2V0PSIwLjcxODc1IiBzdG9wLWNvbG9yPSIjNDQxRkQ4Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzBBMjZCOCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgIconMeasurableResults as ReactComponent };